<template>
    <div class="nk-content-wrap">
      <div class="nk-block-head">
        <div class="nk-block-between">
          <div class="nk-block-head-content">
            <h3 class="nk-block-title page-title">Booking Pages</h3>
          
          </div>
          <div class="nk-block-head-content" v-if="booking_page_status == 0">
            <div class="toggle-wrap nk-block-tools-toggle">
              <a href="#" class="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu">
                <em class="icon ni ni-menu-alt-r"></em>
              </a>
              <div class="toggle-expand-content" data-content="pageMenu">
                <ul class="nk-block-tools g-3">
                  
                  <li class="nk-block-tools-opt">
                    <a href="javascript:void(0);" @click="set_page(1)" class="btn btn-success" style="border-radius: .6rem;">
                      <span>Create Booking Page</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nk-block">
        <div class="row g-gs">
          <div class="col-sm-12" v-if="booking_page_status == 0">
            <div class="card card-bordered" style="border-radius: 1rem; height:100%;" v-if="bookings.length<=0">
              <div class="card-inner" style="text-align: center; width:100%; padding: 1rem;">
                <br>
                <div style="text-align: center; height:15rem; width:100%; padding: 1rem; margin-top: 3rem;">
                  <em style="font-size: 5rem;" class="icon ni ni-calendar-booking"></em>
                  <br>
                  <br>
                  <h6>No upcoming bookings</h6>
                  <p> Need help? Find out more about sharing your booking pages </p>
                </div>
                <br>
                <br>
                <a href="javascript:void(0);" @click="set_page(1)" class="btn btn-success" style="width:30%; border-radius: .6rem;">
                  <span>Create Booking Page</span>
                </a>
              </div>
            </div>
            <div class="nk-block" v-if="bookings.length>0">
              <div class="card card-bordered card-stretch">
                <div class="card-inner-group">
                  <div class="card-inner p-0">
                    <div class="nk-tb-list nk-tb-ulist is-compact">
                      <div class="nk-tb-item nk-tb-head">
                        <div class="nk-tb-col nk-tb-col-check">
                          <div class="custom-control custom-control-sm custom-checkbox notext">
                            <input type="checkbox" class="custom-control-input" id="uid">
                            <label class="custom-control-label" for="uid"></label>
                          </div>
                        </div>
                        <div class="nk-tb-col">
                          <span class="sub-text">Page Title</span>
                        </div>
                        <div class="nk-tb-col tb-col-md">
                          <span class="sub-text">Link</span>
                        </div>
                        <div class="nk-tb-col tb-col-md">
                          <span class="sub-text">Appointments</span>
                        </div>
                        <div class="nk-tb-col tb-col-lg">
                          <span class="sub-text">Is Recurring</span>
                        </div>
                        <div class="nk-tb-col tb-col-lg">
                          <span class="sub-text">Status</span>
                        </div>
                        <div class="nk-tb-col tb-col-lg">
                          <span class="sub-text">Action</span>
                        </div>
                        
                      </div>
                      <div class="nk-tb-item" v-for="user in bookings" :key="user">
                        <div class="nk-tb-col nk-tb-col-check">
                          <div class="custom-control custom-control-sm custom-checkbox notext">
                            <input type="checkbox" class="custom-control-input" id="uid1">
                            <label class="custom-control-label" for="uid1"></label>
                          </div>
                        </div>
                        <div class="nk-tb-col">
                         {{ user.booking_page_title }}
                        </div>
                        <div class="nk-tb-col tb-col-md">
                          <a :href="'/booking/'+user.booking_page_url" target="_blank">
                            <span>{{ base_url+"booking/"+user.booking_page_url }}</span>
                          </a>
                        </div>
                        <div class="nk-tb-col tb-col-md">
                          <a href="/bookings"><span>{{ user.appointments_count }}</span></a>
                        </div>
                        
                        <div class="nk-tb-col">
                          <span class="tb-status text-success" v-if="user.booking_page_recurring==='1'">Yes</span>
                          <span class="tb-status text-success" v-if="user.booking_page_recurring!=='1'">No</span>
                        </div>
                        <div class="nk-tb-col">
                          <span class="tb-status text-success">Active</span>
                        </div>
                        <div class="nk-tb-col nk-tb-col-tools">
                            <div class="drodown">
                                <a href="javascript:void(0)" class="btn btn-sm btn-icon btn-trigger dropdown-toggle" data-bs-toggle="dropdown">
                                  <em class="icon ni ni-more-h"></em>
                                </a>
                                <div class="dropdown-menu dropdown-menu-end">
                                  <ul class="link-list-opt no-bdr">
                                    <li>
                                        <a href="#" @click="copy_url(user)" v-if="user.appointment_meet!=='none'">
                                            <em class="icon ni ni-link"></em>
                                            <span>Copy Link</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" @click="edit_item(user)">
                                            <em class="icon ni ni-edit"></em>
                                            <span>Edit</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" @click="del_item1(user)">
                                            <em class="icon ni ni-trash"></em>
                                            <span>Delete</span>
                                        </a>
                                    </li>
                                </ul>


                                </div>
                              </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-inner">
              <div class="nk-block-between-md g-3">
                <div class="g">
                  <ul class="pagination justify-content-center justify-content-md-start">
                    <li class="page-item">
                      <a class="page-link" v-if="page_no>3" @click="getBookList(page_no-3)" href="javascript:void(0)">Prev</a>
                    </li>
                    <li class="page-item">
                      <a class="page-link" v-if="page_no>2" @click="getBookList(page_no-2)" href="javascript:void(0)">{{ (page_no-2) }}</a>
                    </li>
                    <li class="page-item">
                      <a class="page-link" v-if="page_no>1" @click="getBookList(page_no-1)" href="javascript:void(0)">{{ (page_no-1) }}</a>
                    </li>
                    <li class="page-item">
                      <span class="page-link">
                        <em class="icon ni ni-more-h"></em>
                      </span>
                    </li>
                    <li class="page-item">
                      <a class="page-link" href="javascript:void(0)" @click="getBookList(page_no+1)">{{ (page_no+1) }}</a>
                    </li>
                    <li class="page-item">
                      <a class="page-link" href="javascript:void(0)" @click="getBookList(page_no+2)">{{ (page_no+2) }}</a>
                    </li>
                    <li class="page-item">
                      <a class="page-link" href="javascript:void(0)" @click="getBookList(page_no+3)">Next</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8" v-if="booking_page_status > 0">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="text-align: center; width:100%;">
                <div style="width:100%; text-align: center; margin-bottom: 1rem;">
                  <ul class="nk-stepper-nav inline-list">
                    <li id="step1" class="current">
                      <div class="step-item"></div>
                    </li>
                    <li id="step2">
                      <div class="step-item"></div>
                    </li>
                    <li id="step3">
                      <div class="step-item"></div>
                    </li>
                    <li id="step4">
                      <div class="step-item"></div>
                    </li>
                    <li id="step5">
                      <div class="step-item"></div>
                    </li>
                    <li id="step6">
                      <div class="step-item"></div>
                    </li>
                    <li id="step7">
                      <div class="step-item"></div>
                    </li>
                    <li id="step8">
                      <div class="step-item"></div>
                    </li>
                  </ul>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 1">
                  <h6 style="width:100%; text-align: center;">Create your booking page</h6>
                  <p style="width:100%; text-align: center;"> Enter your booking page title, your link and intro to let people know who they're booking with. </p>
                  <div class="form-group">
                    <label class="form-label" for="page_title"> Your booking page title </label>
                    <div class="form-control-wrap">
                      <input type="text" class="form-control" v-model="bookingDt.booking_page_title" id="page_title" placeholder="Booking page title">
                    </div>
                  </div>
                  <div class="form-control-wrap">
                    <label class="form-label" for="page_url"> Your booking page url </label>
                    <div class="input-group">
                      <div class="input-group-append">
                        <span class="input-group-text">{{base_url}}</span>
                      </div>
                      <input type="text" id="page_url" class="form-control" @change="check_url()" v-model="bookingDt.booking_page_url" placeholder="Your username" required="">
                    </div>
                  </div>
                  <br>
                  <div class="form-group">
                    <label class="form-label" for="page_desc">Booking page intro (Optional)</label>
                    <div class="form-control-wrap">
                      <textarea class="form-control no-resize" v-model="bookingDt.booking_page_intro" id="page_desc"></textarea>
                    </div>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" v-model="bookingDt.booking_page_recurring" id="customCheck7">
                    <label class="custom-control-label" for="customCheck7">Is Recurring?</label>
                  </div>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 2">
                  <h6 style="width:100%; text-align: center;">Add some style</h6>
                  <p style="width:100%; text-align: center;"> Add your photo, your brand color, and page layout to personalise your page further. </p>
                  <div class="row g-gs">
                    <div class="col-sm-2" v-if="bookingDt==null || bookingDt==undefined || bookingDt.booking_page_img==null || bookingDt.booking_page_img==undefined || bookingDt.booking_page_img.length<=0">
                      <div class="user-avatar lg" @click="pick_img()" style="background-color: #efeeee; color:#9b9a9a;">
                        <i class="mdi mdi-camera-plus-outline"></i>
                      </div>
                    </div>
                    <div class="col-sm-2" v-if="bookingDt!=null && bookingDt!=undefined && bookingDt.booking_page_img!=null && bookingDt.booking_page_img!=undefined && bookingDt.booking_page_img.length>0">
                      <div @click="pick_img()">
                        <img :src="sel_image" style="height: 4.7rem; width: 4.9rem; border-radius: 100%; object-fit: cover; object-position: center;" />
                      </div>
                    </div>
                    <input type="file"  id="booking_logo" @change="set_img()" style="display: none;">
                    <div class="col-sm-10">
                      <div class="form-group">
                        <label class="form-label" for="default-01"> Brand Color </label>
                        <div class="form-control-wrap">
                          <div class="row g-gs">
                            <div class="col-sm-2" style="padding-right: 0px !important;">
                              <input type="color" class="form-control" style="padding:0px;" value="#000000" id="clr_code" @change="set_clr()" placeholder="Booking page title">
                            </div>
                            <div class="col-sm-10" style="padding-right: 0px !important;">
                              <input type="text" class="form-control" v-model="bookingDt.booking_page_color" placeholder="#dddddd">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="form-control-wrap">
                    <label class="form-label" for="default-01"> Booking page layout </label>
                    <div class="row g-gs" style="padding: 1rem;">
                      <div class="col-sm-4" style="text-align: center;">
                        <img :src="base_url + 'images/p3.png'" @click="set_rd(1)" style="height:5.5rem; width:auto;" />
                        <br>
                        <div @click="set_rd(1)" class="custom-control custom-control-sm custom-radio" style="margin-top: 1rem;">
                          <input type="radio" @click="set_rd(1)" class="custom-control-input" name="radioSize" id="chk1">
                          <label @click="set_rd(1)" class="custom-control-label" for="chk1">Month</label>
                        </div>
                      </div>
                      <div class="col-sm-4" style="text-align: center;">
                        <img :src="base_url + 'images/p2.png'" @click="set_rd(2)" style="height:5.5rem; width:auto;" />
                        <br>
                        <div @click="set_rd(2)" class="custom-control custom-control-sm custom-radio" style="margin-top: 1rem;">
                          <input @click="set_rd(2)" type="radio" class="custom-control-input" name="radioSize" id="chk2">
                          <label @click="set_rd(2)" class="custom-control-label" for="chk2">Day</label>
                        </div>
                      </div>
                      <div class="col-sm-4" style="text-align: center;">
                        <img :src="base_url + 'images/p1.png'" @click="set_rd(3)" style="height:5.5rem; width:auto;" />
                        <br>
                        <div @click="set_rd(3)" class="custom-control custom-control-sm custom-radio" style="margin-top: 1rem;">
                          <input @click="set_rd(3)" type="radio" class="custom-control-input" name="radioSize" id="chk3">
                          <label @click="set_rd(3)" class="custom-control-label" for="chk3">Week</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 3">
                  <h6 style="width:100%; text-align: center;">Set your availability</h6>
                  <p style="width:100%; text-align: center;"> Set the length of your meetings, and define ranges of time when you're available. </p>
                  <div class="form-group">
                    <label class="form-label" for="default-01"> How long are your meetings for? </label>
                    <div class="form-control-wrap ">
                      <div class="form-control-select">
                        <select class="form-control" v-model="bookingDt.booking_page_duration" id="default-06">
                          <option value="">Select Duration</option>
                          <option value="10 Minutes">10 Minutes</option>
                          <option value="15 Minutes">15 Minutes</option>
                          <option value="20 Minutes">20 Minutes</option>
                          <option value="30 Minutes">30 Minutes</option>
                          <option value="45 Minutes">45 Minutes</option>
                          <option value="1 Hour">1 Hour</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-wrap">
                    <label class="form-label" for="default-01"> What's your typical schedule? </label>
                    <div style="display: flex; text-align: center; font-size: .7rem; margin-bottom: 1rem;">
                      <a href="javascript:void(0)" @click="set_day('Sun')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Sun')">
                        <strong>Sun</strong>
                      </a> &nbsp;&nbsp; <a href="javascript:void(0)" @click="set_day('Mon')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Mon')">
                        <strong>Mon</strong>
                      </a> &nbsp;&nbsp; <a href="javascript:void(0)" @click="set_day('Tue')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Tue')">
                        <strong>Tue</strong>
                      </a> &nbsp;&nbsp; <a href="javascript:void(0)" @click="set_day('Wed')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Wed')">
                        <strong>Wed</strong>
                      </a> &nbsp;&nbsp; <a href="javascript:void(0)" @click="set_day('Thu')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Thu')">
                        <strong>Thu</strong>
                      </a> &nbsp;&nbsp; <a href="javascript:void(0)" @click="set_day('Fri')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Fri')">
                        <strong>Fri</strong>
                      </a> &nbsp;&nbsp; <a href="javascript:void(0)" @click="set_day('Sat')" :style="'border-radius: 100%; width:2.4rem; height:2.2rem; padding:.5rem;'+check_schedule('Sat')">
                        <strong>Sat</strong>
                      </a>
                    </div>
                    <div class="form-control-select">
                      <select class="form-control" v-model="bookingDt.booking_page_hours" id="timing_ops" @change="set_timing()">
                        <option value="">Select Hours</option>
                        <option value="10:00 to 17:00">Office Hours (10 AM to 05 PM)</option>
                        <option value="08:00 to 12:00">Mornings (08 AM to 12 PM)</option>
                        <option value="13:00 to 17:00">Afternoons (01 PM to 05 PM)</option>
                        <option value="18:00 to 22:00">Evenings (06 PM to 10 PM)</option>
                        <option value="Custom">Custom</option>
                      </select>
                    </div>
                    <br>
                    <div class="row g-gs">
                      <div class="col-sm-5">
                        <input type="time" v-model="bookingDt.booking_page_from" class="form-control" id="from_time" value="10:00">
                      </div>
                      <div class="col-sm-2" style="text-align: center; align-items: center;">
                        <h7>To</h7>
                      </div>
                      <div class="col-sm-5">
                        <input type="time"  v-model="bookingDt.booking_page_to" class="form-control" id="to_time" value="17:00">
                      </div>
                    </div>
                    <div class="form-control-wrap" style="margin-top: 1rem;">
                      <label class="form-label" for="default-01"> Buffer Time (In Minutes) </label>
                      <input type="number" class="form-control" v-model="bookingDt.booking_page_buffer_time">
                    </div>
                  </div>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 4">
                  <h6 style="width:100%; text-align: center;">Don't double booked</h6>
                  <p style="width:100%; text-align: center;"> Avoid scheduling conflicts and ensure smooth planning by preventing double bookings effortlessly. </p>
                  <ul class="chat-list" style="width:80%; margin-left: 10%; margin-top: 3rem; margin-bottom: 4rem;">
                    <li class="chat-item">
                      <div style="align-items: center; display: flex;">
                        <div class="chat-media" style="height:3rem; width:3rem;">
                          <img :src="base_url + 'images/cal1.png'" />
                        </div>
                        <div class="chat-info">
                          <div class="chat-from">
                            <div class="name">Google Calendar</div>
                          </div>
                        </div>
                        <a href="javascript:void(0);" 
                        v-if="check_celender(0)" @click="connectGoogleNow()" class="btn btn-success btn-sm" style="border-radius: 10rem;">
                          <span >Connect</span>
                        </a>
                        <a href="javascript:void(0);" 
                        v-if="check_celender(1)" class="btn btn-light btn-sm" style="border-radius: 10rem;">
                          <span >Connected</span>
                        </a>
                      </div>
                    </li>
                    <li class="chat-item" style="margin-top: 1.5rem;">
                      <div style="align-items: center; display: flex;">
                        <div class="chat-media" style="height:3rem; width:3rem;">
                          <img :src="base_url + 'images/cal2.png'" />
                        </div>
                        <div class="chat-info">
                          <div class="chat-from">
                            <div class="name">Microsoft Calendar</div>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius: 10rem;">
                          <span >Connect</span>
                        </a>
                      </div>
                    </li>
                    <li class="chat-item" style="margin-top: 1.5rem;">
                      <div style="align-items: center; display: flex;">
                        <div class="chat-media" style="height:3rem; width:3rem;">
                          <img :src="base_url + 'images/cal3.png'" />
                        </div>
                        <div class="chat-info">
                          <div class="chat-from">
                            <div class="name">Apple Calendar</div>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius: 10rem;">
                          <span >Connect</span>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 5">
                  <h6 style="width:100%; text-align: center;">Connect your gateways</h6>
                  <p style="width:100%; text-align: center;"> Seamlessly integrate and connect your payment gateways for secure and efficient transactions. </p>
                  <ul class="chat-list" style="width:80%; margin-left: 10%; margin-top: 3rem; margin-bottom: 2rem;">
                    <li class="chat-item">
                      <div style="align-items: center; display: flex;">
                        <div class="chat-media" style="height:3rem; width:3rem;">
                          <img :src="base_url + 'images/netivia.png'" />
                        </div>
                        <div class="chat-info">
                          <div class="chat-from">
                            <div class="name">Netivia</div>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius: 10rem;">
                          <span >Connect</span>
                        </a>
                      </div>
                    </li>
                    <li class="chat-item" style="margin-top: 1.5rem;">
                      <div style="align-items: center; display: flex;">
                        <div class="chat-media" style="height:3rem; width:3rem;">
                          <img :src="base_url + 'images/paypal.png'" />
                        </div>
                        <div class="chat-info">
                          <div class="chat-from">
                            <div class="name">Paypal</div>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius: 10rem;">
                          <span >Connect</span>
                        </a>
                      </div>
                    </li>
                    
                  </ul>
                   <div class="row g-gs" style="padding: 1rem;">
                      <div class="col-sm-8">
                        <h6 style="width:100%;">Select Packages</h6>
                      </div>
                      <div class="col-sm-4" style="text-align: right;">
                        <a href="/packages" class="btn btn-sm btn-success" style="border-radius: 0.6rem;">
                          <span data-v-2daf4690="">Add</span>
                        </a>
                      </div>
                    </div>
                  
                  <br>
                  <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
                    <a href="javascript:void(0);" @click="add_pkg(user)"
                    v-for="user in packages" :key="user"
                    :class="'btn '+check_pkg(user)+' btn-sm'" style="border-radius: 10rem;">
                        <span>{{ user.package_name }}</span>
                    </a>
                  </div>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 6">
                  <h6 style="width:100%; text-align: center;">Routing Forms</h6>
                  <p style="width:100%; text-align: center;"> Collect the information before someone books on your calendar. </p>
                  <div class="form-control-wrap">
                    
                    
                   <div class="row g-gs">
                      <div class="col-sm-8">
                        <label class="form-label" for="default-01"> Your form layout </label>
                      </div>
                      <div class="col-sm-4" style="text-align: right;">
                        <a href="/templetes" class="btn btn-sm btn-success" style="border-radius: 0.6rem;">
                          <span data-v-2daf4690="">Add</span>
                        </a>
                      </div>
                    </div>
                    <div class="row g-gs" style="padding: 1rem;">
                      <div class="col-sm-4" v-for="(user,index) in tmps" :key="user" style="text-align: center;">
                        <img v-if="user.form_temp_image!=null && user.form_temp_image!=undefined && user.form_temp_image.length>0 && user.form_temp_image!=='none'" :src="img_base_url +user.form_temp_image" @click="set_rd1(index)" style="height:5.5rem; width:auto;" />
                        <img v-if="user.form_temp_image==null || user.form_temp_image==undefined ||
                         user.form_temp_image.length<=0 ||
                          user.form_temp_image==='none'" src="images/p3.png" @click="set_rd1(index)" style="height:5.5rem; width:auto;" />
                        <br>
                        <div class="custom-control custom-control-sm custom-radio" style="margin-top: 1rem;">
                          <input type="radio" @change="set_rd1(index)" class="custom-control-input" name="radioSize" :id="'chk'+index">
                          <label class="custom-control-label" @click="set_rd1(index)" :for="'chk'+index">{{user.form_temp_title}}</label>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 7">
                  <h6 style="width:100%; text-align: center;">Reminders for meeting</h6>
                  <p style="width:100%; text-align: center;"> Stay organized and never miss important tasks with timely reminders and notifications. </p>
                  <div style="margin-left: 25%; margin-bottom: 2rem; margin-top: 2rem;">
                    <div class="custom-control custom-checkbox" style="margin-top: 1rem;">
                      <input type="checkbox" class="custom-control-input" id="chkd1">
                      <label class="custom-control-label" for="chkd1">
                        <strong>Pre-Meeting Reminders</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top: 1rem;">
                      <input type="checkbox" class="custom-control-input" id="chkd2">
                      <label class="custom-control-label" for="chkd2">
                        <strong>Last-Minute & Just-in-Time Reminders</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top: 1rem;">
                      <input type="checkbox" class="custom-control-input" id="chkd3">
                      <label class="custom-control-label" for="chkd3">
                        <strong>Post-Meeting Reminders</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top: 1rem;">
                      <input type="checkbox" class="custom-control-input" id="chkd4">
                      <label class="custom-control-label" for="chkd4">
                        <strong>Reschedule or Cancellation Reminders</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top: 1rem;">
                      <input type="checkbox" class="custom-control-input" id="chkd5">
                      <label class="custom-control-label" for="chkd5">
                        <strong>Task & Preparation Reminders</strong>
                      </label>
                    </div>
                    <br><br>
                    <div>
                      <a href="/email_templetes" class="btn btn-sm btn-success" style="width: 80%; border-radius: 0.6rem;">
                        <span >Custom Reminder</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div style="text-align: left; width:100%;" v-if="booking_page_status == 8">
                  <h6 style="width:100%; text-align: center;">Choose a location</h6>
                  <p style="width:100%; text-align: center;"> Decide whether you would like to meet in person or a web conference. </p>
                  <div class="form-group" style="margin-top: 3rem;">
                    <label class="form-label" for="default-01"> How do you want to meet? </label>
                    <div class="form-control-wrap ">
                      <div class="form-control-select">
                        <select class="form-control" v-model="bookingDt.booking_page_meet_mode" @change="set_location()">
                          <!-- <option value="Zoom Call">Zoom Call</option> -->
                          <option value="Google Meet">Google Meet</option>
                          <option value="In-Person Meeting">In-Person Meeting</option>
                          <option value="Phone Call">Phone Call</option>
                          <option value="Request Location">Request Location</option>
                          <option value="Custom Location">Custom Location</option>
                          <option value="No Location">No Location</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" id="place1" style="display: none;">
                    <label class="form-label" for="default-01"> Location </label>
                    <div class="form-control-wrap">
                      <input type="text" class="form-control" id="default-01" placeholder="Enter Place or Url">
                    </div>
                  </div>
                </div>
                <br>
                <div :class="'alert alert-' + msgType + ' mb-xl-0'" role="alert"
                                            v-if="msgTxt && msgTxt.length > 0">
                                            {{ msgTxt }}
                                        </div>
                <br>
                <a href="javascript:void(0)" @click="prev_page()" class="btn btn-secondary" style="width:30%; border-radius: .6rem;">
                  <span v-if="booking_page_status>1" >Prev Step</span>
                  <span v-if="booking_page_status<=1" >Cancel</span>
                </a> &nbsp;&nbsp;&nbsp; <a href="javascript:void(0)" @click="next_page()" class="btn btn-success" style="width:30%; border-radius: .6rem;">
                  <span v-if="booking_page_status<8">Next Step </span>
                  <span v-if="booking_page_status>=8">Create Page</span>
                </a>
                <p style="width:100%; margin-top: 1rem; text-align: center;"> Don't worry, you can make changes to this later </p>
              </div>
            </div>
          </div>
          <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" v-if="booking_page_status > 0">
            <img :src="base_url+layout_img" />
            <div :style="'top:'+top1+'%;left:67%; position: absolute; color:#000; width:15rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'">
              <p>{{ base_url+bookingDt.booking_page_url }}</p>
            </div>
            <div id="bg_preview45" :style="'background-color: '+bookingDt.booking_page_color+'; width:40%; height:.7rem; position: absolute; color:#000; top:'+top2+'%;left:61.7%;'"></div>
            <div :style="'position: absolute; color:#000; width:15rem; white-space: nowrap;  overflow: hidden; text-overflow: ellipsis; top:'+top3+'%;left:63.5%;'">
              <h5>{{ bookingDt.booking_page_title }}</h5>
            </div>
            <div :style="'position: absolute; color:#000; width:15rem; word-wrap: break-word; top:'+top4+'%;left:63.5%;'">
              <p style="width:15rem;">{{ bookingDt.booking_page_intro }}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <button style="display: none;" id="delBt45" data-bs-toggle="modal"
    data-bs-target="#delForm" ></button>
    <div class="modal fade" id="delForm">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius:1rem;">
            <div class="modal-header">
                <h6 class="modal-title">Delete</h6>
            </div>
            <div class="modal-body">
                <div class="form-validate is-alter">
                   <p>Are you sure, you want to Delete?</p>
                    <div class="form-group">
                        <button type="button" @click="del_item()" class="btn btn-success" style="border-radius: 0.6rem;">
                            Yes
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button id="btclose45" type="button" data-bs-dismiss="modal"
                        aria-label="Close" class="btn btn-outline-success" style="border-radius: 0.6rem;">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </template>
  <script>
    import {
      mainBaseUrl,
      imgBaseUrl,
      apiBaseUrl
    } from '@/apis/appconst';
    import {
    getMyDt
  } from '@/apis/webapis';

    import { getList  as getTmpList } from '@/apis/tmpapis';

    import { getList  as getPkgList } from '@/apis/pkgapis';
    import { getBookingList,addBooking,deleteBookingById,getBookingByUrl,uploadImg } from '@/apis/bookingpageapis';

    export default {
      name: 'AppBookings',
      methods: {
        check_celender(rtype){
          this.bookingDt.booking_page_google_calender = this.ldata.google_refresh_token;
          if(rtype==1){
            if((this.bookingDt.booking_page_google_calender+"").length>0){
              return true;
            }
          }
          else{
            if((this.bookingDt.booking_page_google_calender+"").length<=0){
              return true;
            }
          }
          return false;
        },
        async getMyDtCall() {
          const response = await getMyDt(this.ldata.user_id);
        if (response.status) {
          this.ldata = response.user;
          
          this.bookingDt.booking_page_google_calender = this.ldata.google_refresh_token;
          sessionStorage.setItem("ldata",JSON.stringify(this.ldata));
        }
        },
        connectGoogleNow() {
          const url = apiBaseUrl+"google/connect/google?user_id="+this.ldata.user_id; // Backend Express route
          const popup = window.open(url, "popupWindow", "width=600,height=600");

          if (!popup) {
            alert("Popup blocked! Please allow popups.");
            return;
          }

          // Listen for message from popup
          window.addEventListener("message", (event) => {
            console.log("sdas",event);
            this.getMyDtCall();
        }, false);
        },
        valField1(field, msg) {
            if (field.length > 0) {
                return true;
            } else {
                this.msgType = "danger";
                this.msgTxt = msg;
                return false;
            }
        },
        async getBookList($page_no) {
                this.page_no = $page_no;
                const response = await getBookingList(this.page_no,this.count,this.ldata.user_id);
                if (response.status) {
                  this.bookings = response.records;
                  this.totalRecords = response.pagination.totalRecords;
                }
        },
        edit_item($bookDt){
          this.bookingDt.booking_page_id = $bookDt.booking_page_id;
          this.bookingDt.booking_page_title = $bookDt.booking_page_title;
          this.bookingDt.booking_page_url = $bookDt.booking_page_url;
          this.bookingDt.booking_page_intro = $bookDt.booking_page_intro;
          this.bookingDt.booking_page_recurring = $bookDt.booking_page_recurring;
          this.bookingDt.booking_page_color = $bookDt.booking_page_color;
          this.bookingDt.booking_page_img = $bookDt.booking_page_img;
          this.bookingDt.booking_page_layout_type = $bookDt.booking_page_layout_type;
          this.bookingDt.booking_page_duration = $bookDt.booking_page_duration;
          if($bookDt.booking_page_schedule!=null 
          && $bookDt.booking_page_schedule!=undefined 
          && $bookDt.booking_page_schedule.length>0){
            this.bookingDt.booking_page_schedule = JSON.parse($bookDt.booking_page_schedule);
          }
          this.bookingDt.booking_page_hours = $bookDt.booking_page_hours;
          this.bookingDt.booking_page_from = $bookDt.booking_page_from;
          this.bookingDt.booking_page_to = $bookDt.booking_page_to;
          this.bookingDt.booking_page_buffer_time = $bookDt.booking_page_buffer_time;
          this.bookingDt.booking_page_google_calender = $bookDt.booking_page_google_calender;
          this.bookingDt.booking_page_pay_gateway = $bookDt.booking_page_pay_gateway;
          if($bookDt.booking_page_packages!=null &&
           $bookDt.booking_page_packages!=undefined &&
            $bookDt.booking_page_packages.length>0){
            this.bookingDt.booking_page_packages = JSON.parse($bookDt.booking_page_packages);
          }
          this.bookingDt.booking_page_form_layout = $bookDt.booking_page_form_layout;
          this.bookingDt.booking_page_reminders = $bookDt.booking_page_reminders;
          this.bookingDt.booking_page_meet_mode = $bookDt.booking_page_meet_mode;
          this.bookingDt.booking_page_location = $bookDt.booking_page_location;
          this.booking_page_status = 1;

        },
        del_item1($bookDt){
          this.item_id = $bookDt.booking_page_id;
        
          document.getElementById("delBt45").click();
        },
        async del_item() {
                const response = await deleteBookingById(this.item_id);
                if (response.status) {
                  document.getElementById("btclose45").click()
                  this.getBookList(1);
                }
        },
        async next_page() {
          if(this.booking_page_status == 1){
            var fnd = await this.check_url();
           
             if((fnd+"").localeCompare("true")==0){
                if (this.valField1(this.bookingDt.booking_page_title, 'Enter Page Title') &&
                this.valField1(this.bookingDt.booking_page_url, 'Enter Page Url')) {
                  this.msgType = "";
                  this.msgTxt = "";
                }
                else{
                  return;
                }
              }
              else{
                return;
              }
            }
            else if(this.booking_page_status == 2){
              if (this.valField1(this.bookingDt.booking_page_color, 'Select Brand Color') &&
              this.valField1(this.bookingDt.booking_page_layout_type, 'Select Layout')) {
                this.msgType = "";
                this.msgTxt = "";
              }
              else{
                return;
              }
            }
            else if(this.booking_page_status == 3){
              if (this.valField1(this.bookingDt.booking_page_duration, 'Select Duration') &&
              this.valField1(this.bookingDt.booking_page_hours, 'Select Hours') &&
              this.valField1(this.bookingDt.booking_page_from, 'Select From') &&
              this.valField1(this.bookingDt.booking_page_to, 'Select To')) {
                this.msgType = "";
                this.msgTxt = "";
              }
              else{
                return;
              }
            }
            else if(this.booking_page_status == 5){
              // if (this.valField1(this.bookingDt.booking_page_packages, 'Select Pakcages')) {
              //   this.msgType = "";
              //   this.msgTxt = "";
              // }
              // else{
              //   return;
              // }
            }
            else if(this.booking_page_status == 6){
              // if (this.valField1(this.bookingDt.booking_page_form_layout, 'Select Form Layout')) {
              //   this.msgType = "";
              //   this.msgTxt = "";
              // }
              // else{
              //   return;
              // }
            }
            else if(this.booking_page_status == 8){
              if (this.valField1(this.bookingDt.booking_page_meet_mode, 'Select Meeting Mode')) {
                
                if(this.bookingDt.booking_page_meet_mode.localeCompare("Custom Location")==0){
                  if (this.valField1(this.bookingDt.booking_page_location, 'Enter Location')) {
                    this.msgType = "";
                    this.msgTxt = "";
                  }
                  else{
                    return;
                  }
                }
               this.create_page();
              }
              else{
                return;
              }
            }
            if (this.booking_page_status < 8) {
              
              this.booking_page_status++;
              this.set_page(this.booking_page_status);
            }
        },
        async check_url(){
          const response1 = await getBookingByUrl(this.bookingDt.booking_page_url);
              if (response1.status) {
                if((this.bookingDt.booking_page_id+"").length>0){
                  var page_dt = response1.page_dt;
                  if(page_dt.booking_page_url.localeCompare(this.bookingDt.booking_page_url)!=0){
                    this.msgType = "danger";
                    this.msgTxt = "Booking Url Already Exist";
                    return false;
                  }
                }
                else{
                  this.msgType = "danger";
                  this.msgTxt = "Booking Url Already Exist";
                  return false;
                }
              }

              this.msgType = "";
              this.msgTxt = "";
              return true;
        },
        copy_url(user){
          const copyText = this.base_url+"booking/"+user.booking_page_url;
          navigator.clipboard.writeText(copyText)
            .then(() => alert("Copied!!"))
            .catch(err => console.error("Error copying: ", err));

        },
        async create_page(){
              this.msgType = "";
              this.msgTxt = "";

                var bookingData = {
                  booking_page_id:this.bookingDt.booking_page_id,
                  booking_page_title:this.bookingDt.booking_page_title,
                  booking_page_url:this.bookingDt.booking_page_url,
                  booking_page_intro:this.bookingDt.booking_page_intro,
                  booking_page_recurring:this.bookingDt.booking_page_recurring,
                  booking_page_color:this.bookingDt.booking_page_color,
                  booking_page_img:this.bookingDt.booking_page_img,
                  booking_page_layout_type:this.bookingDt.booking_page_layout_type,
                  booking_page_duration:this.bookingDt.booking_page_duration,
                  booking_page_schedule: JSON.stringify(this.bookingDt.booking_page_schedule),
                  booking_page_hours:this.bookingDt.booking_page_hours,
                  booking_page_from:this.bookingDt.booking_page_from,
                  booking_page_to:this.bookingDt.booking_page_to,
                  booking_page_buffer_time:this.bookingDt.booking_page_buffer_time,
                  booking_page_google_calender:this.bookingDt.booking_page_google_calender,
                  booking_page_pay_gateway:this.bookingDt.booking_page_pay_gateway,
                  booking_page_packages:JSON.stringify(this.bookingDt.booking_page_packages),
                  booking_page_form_layout:this.bookingDt.booking_page_form_layout,
                  booking_page_reminders:this.bookingDt.booking_page_reminders,
                  booking_page_meet_mode:this.bookingDt.booking_page_meet_mode,
                  booking_page_location:this.bookingDt.booking_page_location,
                  booking_page_cre_by:this.ldata.user_id
                };

                const response = await addBooking(bookingData);

                if (response.status) {
                  sessionStorage.removeItem("booking_page_status");
                  sessionStorage.removeItem("bookingDt");

                  this.msgType = "success";
                  this.msgTxt = response.message;
                  this.booking_page_status = 0;

                  this.getBookList(1);
                  this.bookingDt.booking_page_id = "";
                  this.bookingDt.booking_page_title = "";
                  this.bookingDt.booking_page_url = "";

                  this.bookingDt.booking_page_intro = "";
                  this.bookingDt.booking_page_recurring = "";
                  this.bookingDt.booking_page_color = "#1ee0ac";

                  this.bookingDt.booking_page_img = "";
                  this.bookingDt.booking_page_layout_type = "";
                  this.bookingDt.booking_page_duration = "";

                  this.bookingDt.booking_page_schedule = [];
                  this.bookingDt.booking_page_hours = "";
                  this.bookingDt.booking_page_from = "";

                  this.bookingDt.booking_page_to = "";
                  this.bookingDt.booking_page_buffer_time = "";
                  this.bookingDt.booking_page_google_calender = "";

                  this.bookingDt.booking_page_pay_gateway = "";
                  this.bookingDt.booking_page_packages = [];
                  this.bookingDt.booking_page_form_layout = "";

                  this.bookingDt.booking_page_reminders = "";
                  this.bookingDt.booking_page_meet_mode = "";
                  this.bookingDt.booking_page_location = "";

                } else {
                  this.msgType = "danger";
                  this.msgTxt = response.message;
                }
        },
        prev_page() {
          
          if (this.booking_page_status > 1) {
            this.booking_page_status--;
            this.set_page(this.booking_page_status);
          }
          else  if (this.booking_page_status == 1) {
           this.booking_page_status = 0;
           sessionStorage.removeItem("bookingDt");
           sessionStorage.removeItem("booking_page_status");
          }
        },
        set_timing() {
          var str = this.bookingDt.booking_page_hours;
          if (str.includes("to")) {
            var tmp = str.split(" to ");
            this.bookingDt.booking_page_from = tmp[0];
            this.bookingDt.booking_page_to = tmp[1];
          }
        },
        check_pkg(user){
          if(this.bookingDt.booking_page_packages.includes(user.package_id)){
            return "btn-success";
          }
          return "btn-light";
        },
        add_pkg(user){
          if(this.bookingDt.booking_page_packages.includes(user.package_id)){
            this.bookingDt.booking_page_packages = this.bookingDt.booking_page_packages.filter(item => item !== user.package_id);
          }
          else{
            this.bookingDt.booking_page_packages.push(user.package_id)
          }
        },
        set_location() {
          if (this.bookingDt.booking_page_meet_mode.localeCompare("Custom Location") == 0) {
            document.getElementById("place1").style.display = "block";
          } else {
            document.getElementById("place1").style.display = "none";
          }
        },
        set_clr() {
          if ((document.getElementById("clr_code").value + "").length > 0) {
            this.bookingDt.booking_page_color = document.getElementById("clr_code").value;
          }
        },
        set_rd($pos) {
          switch($pos){
            case 1:
                this.bookingDt.booking_page_layout_type = "Month";
                this.layout_img = "images/page_lt.png";
              break;
              case 2:
              this.bookingDt.booking_page_layout_type = "Day";
                this.layout_img = "images/page_lt1.png";
              break;
              case 3:
              this.bookingDt.booking_page_layout_type = "Week";
                this.layout_img = "images/page_lt2.png";
              break;
          }
          for (var x = 0; x < 3; x++) {
            if ($pos == (x + 1)) {
              document.getElementById("chk" + (x + 1)).checked = true;
            } else {
              document.getElementById("chk" + (x + 1)).checked = false;
            }
          }
        },
        set_rd1($pos) {
          for (var x = 0; x < this.tmps.length; x++) {
            if ($pos == x) {
              this.bookingDt.booking_page_form_layout =  this.tmps[x].form_temp_id+"";
              document.getElementById("chk" + x).checked = true;
            } else {
              document.getElementById("chk" + x).checked = false;
            }
          }
        },
        check_schedule($day_name){
          if(this.bookingDt.booking_page_schedule.includes($day_name)){
              return "background-color: #364a63; color:#ffffff;";
          }
          return "background-color: #efeeee; color:#9b9a9a;";
        },
        set_day($day_name){
          if(this.bookingDt.booking_page_schedule.includes($day_name)){
            var index = this.bookingDt.booking_page_schedule.indexOf($day_name);
            if (index !== -1) {
              this.bookingDt.booking_page_schedule.splice(index, 1);
            }
          }
          else{
            this.bookingDt.booking_page_schedule.push($day_name);
          }
        },
        pick_img(){
          document.getElementById("booking_logo").click();
        },
        async set_img(){
          if( document.getElementById("booking_logo").files.length>0){
            const response = await uploadImg(document.getElementById('booking_logo').files[0]);
            if (response.status) {
              this.bookingDt.booking_page_img = response.data;
              this.sel_image = apiBaseUrl+response.data;
             
            }
            else{
                alert(response.message);
            }
          }
        },
        async getPkgs() {
                const response = await getPkgList("1","20",this.ldata.user_id);
                if (response.status) {
                  this.packages = response.records;
                }
        }
        ,
        async getTmps() {
                const response = await getTmpList("1","20",this.ldata.user_id);
                if (response.status) {
                  this.tmps = response.records;
                }
        }
        ,
        set_page($pos) {
          try {
            this.booking_page_status = $pos;
            sessionStorage.setItem("booking_page_status",this.booking_page_status);
            sessionStorage.setItem("bookingDt",JSON.stringify(this.bookingDt));
            
            switch(this.booking_page_status){
              case 1:
                this.top1 = 13;
                this.top2 = 16.6;
                this.top3 = 34;
                this.top4 = 46
                break;
              case 2:
                this.top1 = 14;
                this.top2 = 17.6;
                this.top3 = 34;
                this.top4 = 46
                break;
              case 3:
                this.top1 = 14;
                this.top2 = 17.6;
                this.top3 = 34;
                this.top4 = 46;
                break;
              case 4:
                this.top1 = 14;
                this.top2 = 17.6;
                this.top3 = 34;
                this.top4 = 46;
                break;
              case 5:
                this.top1 = 13.7;
                this.top2 = 17.3;
                this.top3 = 34;
                this.top4 = 46;
                break;
              case 6:
                this.top1 = 13.9;
                this.top2 = 17.5;
                this.top3 = 34;
                this.top4 = 46;
                break;
              case 7:
                this.top1 = 14;
                this.top2 = 17.6;
                this.top3 = 34;
                this.top4 = 46;
                break;
              case 8:
                this.top1 = 14;
                this.top2 = 17.6;
                this.top3 = 34;
                this.top4 = 46;
                break;
            }
            if (this.booking_page_status > 0) {
              for (var x = 0; x < 8; x++) {
                if (this.booking_page_status == (x + 1)) {
                  document.getElementById("step" + (x + 1)).className = "current";
                } else {
                  document.getElementById("step" + (x + 1)).className = "";
                }
              }
            }
          } catch (err) {
            // console.log("1");
          }
        }
      },
      data() {
        return {
          base_url: "",
          packages: [],
          bookings: [],
          tmps:[],
          img_base_url:imgBaseUrl,
          count:"10",
          totalRecords:"0",
          page_no:1,
          msgType : "",
          msgTxt : "",
          item_id:"",
          booking_page_status: 0,
          ldata:null,
          layout_img:'images/page_lt.png',
          sel_file:null,
          sel_image:"",
          bookingDt:{
            booking_page_id:"",
            booking_page_title:"",
            booking_page_url:"",
            booking_page_intro:"",
            booking_page_recurring:"",
            booking_page_color:"#000000",
            booking_page_img:"",
            booking_page_layout_type:"",
            booking_page_duration:"",
            booking_page_schedule: ["Mon","Tue","Wed","Thu","Fri"],
            booking_page_hours:"",
            booking_page_from:"",
            booking_page_to:"",
            booking_page_buffer_time:"",
            booking_page_google_calender:"",
            booking_page_pay_gateway:"",
            booking_page_packages:[],
            booking_page_form_layout:"",
            booking_page_reminders:"",
            booking_page_meet_mode:"",
            booking_page_location:""
          },
          top1:13,
          top2:16.6,
          top3:34,
          top4:46
        };
      },
      created() {
        this.base_url = mainBaseUrl;
        
        if(sessionStorage.getItem("booking_page_status") && sessionStorage.getItem("booking_page_status").length>0){
          this.booking_page_status = parseInt(sessionStorage.getItem("booking_page_status")+"");
          var self = this;
          setTimeout(function() {
              if (self.booking_page_status > 0) {
              for (var x = 0; x < 8; x++) {
                if (self.booking_page_status == (x + 1)) {
                  document.getElementById("step" + (x + 1)).className = "current";
                } else {
                  document.getElementById("step" + (x + 1)).className = "";
                }
              }
            }
          }, 1000);
        }
        if(sessionStorage.getItem("bookingDt") && sessionStorage.getItem("bookingDt").length>0){
          this.bookingDt = JSON.parse(sessionStorage.getItem("bookingDt")+"");
        }
        if(sessionStorage.getItem("ldata") && sessionStorage.getItem("ldata").length>0){
          this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
          this.getMyDtCall();
          this.getPkgs();
          this.getTmps()
          this.getBookList(1);
        }
      },
    }
  </script>
  <style scoped>
    .inline-list {
      margin-bottom: 1rem;
      list-style: none;
      padding: 0;
      display: flex;
      margin-left: 1rem;
      justify-content: center;
    }
  
    .inline-list li {
      display: inline-block;
      margin-right: 0px;
    }
  </style>